export function formatDate(dateString, year = false) {
    const date = new Date(dateString)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    if (year) return `${day}.${month}.${date.getFullYear()}`

    return `${day}.${month}.`
}

export function formatDateRange(startDate, endDate) {
    if (!startDate || !endDate) return ''
    return `${formatDate(new Date(startDate))} - ${formatDate(new Date(endDate))}`
}

export function getDayName(day, long = false) {
    return new Date(day).toLocaleDateString('de-DE', { weekday: long ? 'long' : 'short' })
}

export function getWeekInfo(weekDates) {
    if (weekDates.length === 0) return ''

    const firstDate = new Date(weekDates[0])

    const yearStart = new Date(firstDate.getFullYear(), 0, 1)
    const days = Math.floor((firstDate - yearStart) / (24 * 60 * 60 * 1000))
    const weekNumber = Math.ceil((firstDate.getDay() + 1 + days) / 7)

    return `KW ${weekNumber} (${formatDateRange(weekDates[0], weekDates[weekDates.length - 1])})`
}
